import React from 'react';
import './LeadershipSection.css';

interface Leader {
  id: string;
  name: string;
  title: string;
  bio: string;
  credentials: string[];
  initials: string;
  photo?: string;
}

interface LeadershipSectionProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  leaders: Leader[];
  className?: string;
}

const LeadershipSection: React.FC<LeadershipSectionProps> = ({
  eyebrow,
  title = "Leadership Team",
  subtitle = "Meet the experienced professionals guiding our investment strategy",
  leaders,
  className = ""
}) => {
  return (
    <section className={`leadership-section ${className}`}>
      <div className="section-container">
        <div className="section-header">
          {eyebrow && <div className="eyebrow centered">{eyebrow}</div>}
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="leadership-rows">
          {leaders.map(leader => (
            <div key={leader.id} className="leader-row">
              <div className="leader-image">
                {leader.photo ? (
                  <img
                    src={leader.photo}
                    alt={leader.name}
                    className="leader-photo"
                  />
                ) : (
                  <div className="leader-avatar">{leader.initials}</div>
                )}
              </div>
              <div className="leader-info">
                <div className="leader-head">
                  <h3>{leader.name}</h3>
                  <span className="leader-title">{leader.title}</span>
                </div>
                <p className="leader-bio">{leader.bio}</p>
                <div className="leader-credentials">
                  {leader.credentials.map((credential, index) => (
                    <span key={index}>{credential}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
